<div class="progress-loader" *ngIf="loading">
    <div class="loading-spinner">
        <img src="assets/index.svg" alt="Caricamento">
        <span class="loading-message">Please wait...</span>
    </div>
</div>
